<script>
    export default {
        inserted: function (el) {
            let tabs = el.querySelectorAll('li');
            let descriptions = el.querySelectorAll('.description');
            let images = el.querySelectorAll('img');

            let setOnClick = function (element, index) {
                element.onclick = function (e) {
                    e.preventDefault();

                    for (let i = 0; i < tabs.length; i++) {
                        tabs[i].classList.remove('active');
                        descriptions[i].style.display = 'none';
                        images[i].style.display = 'none';
                    }

                    for (let i = 0; i < tabs.length; i++) {
                        if (i === index) {
                            tabs[i].classList.add('active');
                            descriptions[i].style.display = 'block';
                            images[i].style.display = 'block';
                        }
                    }
                }
            }

            for (let i = 0; i < tabs.length; i++) {
                setOnClick(tabs[i], i);
            }

        }
    }

</script>
